import { Breadcrumb } from 'module/ui/components/atoms/breadcrumb';
import { Page } from 'module/ui/components/molecules/page/page';
import { Argon, ArgonProps } from 'module/ui/components/templates/argon';
import { faSalesforce } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from '@rocketlane/rocket-router';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IconWrapper } from 'components/common/styles';

type Props = Omit<ArgonProps, 'title' | 'breadcrumbs' | 'documentTitle'>;

const getIntegrationsPath = () => {
  const isEmbeddedInRocketFrontend =
    typeof window !== 'undefined' &&
    window.location.pathname.includes('/settings/integrations/salesforce-v2');

  return isEmbeddedInRocketFrontend
    ? '/settings/integrations'
    : '/settings/signal-configurations';
};

const SalesforceLayout: FC<Props> = ({ ...rest }) => {
  return (
    <Argon
      documentTitle={'Salesforce'}
      breadcrumbs={
        <>
          <Breadcrumb.Item>
            <Link to={getIntegrationsPath()}>
              <FormattedMessage id="integrations.page.title" />
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>&nbsp;</Breadcrumb.Item>
        </>
      }
      title={
        <IconWrapper>
          <FontAwesomeIcon icon={faSalesforce} />
          <Page.Header.Title>Salesforce</Page.Header.Title>
        </IconWrapper>
      }
      {...rest}
    />
  );
};

export { SalesforceLayout };
